var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C8.37128 0 8.712 0.205702 8.88492 0.534254L15.8849 13.8343C16.0481 14.1442 16.0371 14.517 15.8561 14.8168C15.675 15.1167 15.3503 15.3 15 15.3H1C0.447715 15.3 0 14.8523 0 14.3C0 14.1249 0.0449883 13.9604 0.124035 13.8172L7.11508 0.534254C7.288 0.205702 7.62872 0 8 0ZM7 10H9V5H7V10ZM7 12C7 12.6 7.4 13 8 13C8.6 13 9 12.6 9 12C9 11.4 8.6 11 8 11C7.4 11 7 11.4 7 12Z","fill":"#181818"}));
}

Warning.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
